// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/header/Header.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/header/Header.tsx");
  import.meta.hot.lastModified = "1750073503846.9897";
}
// REMIX HMR END

import { Link, useLocation } from '@remix-run/react';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { SearchBar } from '~/components/header/SearchBar';
import { useRootLoader } from '~/utils/use-root-loader';
import { UserIcon } from '@heroicons/react/24/solid';
import { useScrollingUp } from '~/utils/use-scrolling-up';
import { classNames } from '~/utils/class-names';
import { useTranslation } from 'react-i18next';
import { LanguagePicker } from './LanguagePicker';
import { useState } from 'react';
export function Header({
  onCartIconClick,
  cartQuantity
}) {
  _s();
  const data = useRootLoader();
  const isSignedIn = !!data.activeCustomer.activeCustomer?.id;
  const isScrollingUp = useScrollingUp();
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isHomepage = location.pathname === '/' || location.pathname === '/o-nas' || location.pathname === '/about-us';
  const logoPath = isHomepage ? '/logo-white.svg' : '/logo.svg';
  const collectionLimit = Number(data.env?.PUBLIC_HEADER_COLLECTION_LIMIT ?? 3);
  return <header className={classNames(isScrollingUp ? 'sticky top-0 animate-dropIn' : '', 'transform relative z-10')}>
      <div className={classNames(isHomepage ? 'bg-white text-black' : 'bg-gold1 text-white', 'text-center text-sm')}>
        <div className="max-w-7xl mx-auto flex items-center justify-between py-2 px-6">
          <div>{t('vendure.reopening')}</div>
          <div>
            <Link to={isSignedIn ? '/account' : '/sign-in'} className="flex space-x-1">
              <UserIcon className="w-4 h-4"></UserIcon>
              <span>
                {isSignedIn ? t('account.myAccount') : t('account.signIn')}
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className={classNames(isHomepage ? 'text-white bg-transparent' : 'bg-white', '')}>
        <div className="max-w-7xl mx-auto py-4 px-6 flex items-center justify-between">
          <div className="flex items-center gap-12">
            <Link to="/">
              <img src={logoPath} width={46} height={56} alt={t('commmon.logoAlt')} />
            </Link>

            {/* Desktop Navigation */}
            <div className="gap-6 hidden sm:flex">
              {data.collections.slice(0, collectionLimit).map(collection => <Link className={classNames(isHomepage ? 'text-white' : 'text-black', 'text-sm md:text-base font-semibold')} to={'/collections/' + collection.slug} prefetch="intent" key={collection.id}>
                  {collection.name}
                </Link>)}

              <Link className={classNames(isHomepage ? 'text-white' : 'text-black', 'text-sm md:text-base font-semibold')} to={'/o-nas'}>
                {t('about.name')}
              </Link>

              <Link className={classNames(isHomepage ? 'text-white' : 'text-black', 'text-sm md:text-base font-semibold')} to={'/kontakt'}>
                {t('contact.title')}
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-10">
            <div className="w-[420px] hidden lg:block flex-1">
              <SearchBar></SearchBar>
            </div>

            <div className="flex items-center gap-4">
              {/* Mobile menu button */}
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={classNames(isHomepage ? 'border-gray-400' : 'border-gold2', 'border relative size-12 rounded-md bg-transparent sm:hidden flex items-center justify-center')} style={isHomepage ? {
              background: `
                          linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%),
                          rgba(255, 255, 255, 0.10)
                        `
            } : undefined}>
                {isMobileMenuOpen ? <XMarkIcon className={classNames(isHomepage ? 'text-white' : 'text-black', 'size-6')} /> : <Bars3Icon className={classNames(isHomepage ? 'text-white' : 'text-black', 'size-6')} />}
              </button>

              <button className={classNames(isHomepage ? 'border-gray-400' : 'border-gold2', 'border relative size-12 rounded-md bg-transparent text-white p-3 flex items-center justify-center')} onClick={onCartIconClick} aria-label="Open cart tray" style={isHomepage ? {
              background: `
                          linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%),
                          rgba(255, 255, 255, 0.10)
                        `
            } : undefined}>
                <ShoppingBagIcon className={classNames(isHomepage ? 'text-white' : 'text-black', 'size-6')}></ShoppingBagIcon>
                {cartQuantity ? <div className="absolute rounded-full -top-2 -right-2 bg-primary-600 min-w-6 min-h-6 flex items-center justify-center text-xs p-1">
                    {cartQuantity}
                  </div> : ''}
              </button>

              <LanguagePicker />
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={classNames('fixed inset-0 bg-black bg-opacity-50 sm:hidden transition-opacity duration-300 z-50', isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none')} onClick={() => setIsMobileMenuOpen(false)}>
          <div className={classNames('fixed inset-y-0 left-0 w-full max-w-sm bg-white transform transition-transform duration-300 ease-in-out', isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full')} onClick={e => e.stopPropagation()}>
            <div className="p-6 bg-white">
              {/* Close button */}
              <button onClick={() => setIsMobileMenuOpen(false)} className="absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-700">
                <XMarkIcon className="h-6 w-6" />
              </button>

              {/* Navigation links */}
              <div className="space-y-4 mt-8">
                {data.collections.map(collection => <Link className="block text-black text-base font-semibold hover:text-gold1" to={'/collections/' + collection.slug} prefetch="intent" key={collection.id} onClick={() => setIsMobileMenuOpen(false)}>
                    {collection.name}
                  </Link>)}

                <Link className="block text-black text-base font-semibold hover:text-gold1" to={'/o-nas'} onClick={() => setIsMobileMenuOpen(false)}>
                  {t('about.name')}
                </Link>

                <Link className="block text-black text-base font-semibold hover:text-gold1" to={'/kontakt'} onClick={() => setIsMobileMenuOpen(false)}>
                  {t('contact.title')}
                </Link>
              </div>

              {/* Search bar */}
              <div className="pt-6 border-t mt-6">
                <SearchBar />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>;
}
_s(Header, "VOl1ucuARXUdSwezwqpqHLe183c=", false, function () {
  return [useRootLoader, useScrollingUp, useTranslation, useLocation];
});
_c = Header;
var _c;
$RefreshReg$(_c, "Header");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;